export default __webpack_public_path__ + "static/media/CreepImg.64c6a069.jpg";